module.exports = __webpack_public_path__ + "static/img/14000149.29d2f96a.png";